export const modal_catalog = {
  approval_rule: {
    title: 'New matrix rule',
    subtitle: 'Who can approve a transaction, by amount band, department, category and risk.',
    primary_label: 'Create',
    fields: [
      { label: 'Transaction type', type: 'input', placeholder: 'e.g. Capital expenditure', class: 'col-12' },
      { label: 'Category', type: 'select', value: 'General expenditure', options: ['General expenditure', 'Capital expenditure', 'Procurement / PO', 'Contract value'], class: 'col-12 col-md-6' },
      { label: 'Department', type: 'select', value: 'All', options: ['All', 'Finance', 'Procurement', 'Legal', 'Operations'], class: 'col-12 col-md-6' },
      { label: 'Amount band / condition', type: 'input', placeholder: 'e.g. R 50 000 - R 500 000', class: 'col-12 col-md-6' },
      { label: 'Risk level', type: 'select', value: 'Low', options: ['Low', 'Medium', 'High'], class: 'col-12 col-md-6' },
      { label: 'Required approver', type: 'input', placeholder: 'e.g. Executive (CFO)', class: 'col-12 col-md-6' },
      { label: 'Second approver (if dual)', type: 'input', placeholder: 'Optional', class: 'col-12 col-md-6' },
      { label: 'Note', type: 'input', placeholder: 'Conditions / requirements', class: 'col-12' }
    ]
  },
  financial_threshold: {
    title: 'New financial threshold',
    subtitle: 'An amount band and the authority it requires. Drives the resolver.',
    primary_label: 'Create',
    fields: [
      { label: 'Category', type: 'select', value: 'General expenditure', options: ['General expenditure', 'Capital expenditure', 'Procurement / PO', 'Contract value'], class: 'col-12 col-md-6' },
      { label: 'From (R, inclusive)', type: 'input', value: '0', placeholder: '0', class: 'col-12 col-md-6' },
      { label: 'To (R, exclusive - blank = no ceiling)', type: 'input', placeholder: 'blank for top band', class: 'col-12 col-md-6' },
      { label: 'Approver', type: 'input', placeholder: 'e.g. CFO', class: 'col-12 col-md-6' },
      { label: 'Second approver', type: 'input', placeholder: 'Optional', class: 'col-12 col-md-6' }
    ]
  },
  financial_threshold_edit: {
    title: 'Edit financial threshold',
    subtitle: 'An amount band and the authority it requires. Drives the resolver.',
    primary_label: 'Save changes',
    secondary_label: 'Delete',
    fields: [
      { label: 'Category', type: 'select', value: 'General expenditure', options: ['General expenditure', 'Capital expenditure', 'Procurement / PO', 'Contract value'], class: 'col-12 col-md-6' },
      { label: 'From (R, inclusive)', type: 'input', value: '0', placeholder: '0', class: 'col-12 col-md-6' },
      { label: 'To (R, exclusive - blank = no ceiling)', type: 'input', placeholder: 'blank for top band', class: 'col-12 col-md-6' },
      { label: 'Approver', type: 'input', placeholder: 'e.g. CFO', class: 'col-12 col-md-6' },
      { label: 'Second approver', type: 'input', placeholder: 'Optional', class: 'col-12 col-md-6' }
    ]
  },
  procurement_authority: {
    title: 'New procurement authority',
    subtitle: 'Who approves a procurement action and the evidence required.',
    primary_label: 'Create',
    fields: [
      { label: 'Action', type: 'select', value: 'Supplier registration', options: ['Supplier registration', 'Purchase order', 'Deviation from procurement process', 'Emergency procurement', 'Contract award'], class: 'col-12 col-md-6' },
      { label: 'Condition', type: 'input', placeholder: 'e.g. Standard-risk supplier', class: 'col-12 col-md-6' },
      { label: 'Approver', type: 'input', placeholder: 'e.g. SCM Manager', class: 'col-12 col-md-6' },
      { label: 'Evidence required', type: 'input', placeholder: 'e.g. 3 quotes / RFQ pack', class: 'col-12 col-md-6' }
    ]
  },
  procurement_authority_edit: {
    title: 'Edit procurement authority',
    subtitle: 'Who approves a procurement action and the evidence required.',
    primary_label: 'Save changes',
    secondary_label: 'Delete',
    fields: [
      { label: 'Action', type: 'select', value: 'Supplier registration', options: ['Supplier registration', 'Purchase order', 'Deviation from procurement process', 'Emergency procurement', 'Contract award'], class: 'col-12 col-md-6' },
      { label: 'Condition', type: 'input', placeholder: 'e.g. Standard-risk supplier', class: 'col-12 col-md-6' },
      { label: 'Approver', type: 'input', placeholder: 'e.g. SCM Manager', class: 'col-12 col-md-6' },
      { label: 'Evidence required', type: 'input', placeholder: 'e.g. 3 quotes / RFQ pack', class: 'col-12 col-md-6' }
    ]
  },
  contract_authority: {
    title: 'New contract authority',
    subtitle: 'Who approves a contract action and the evidence required.',
    primary_label: 'Create',
    fields: [
      { label: 'Action', type: 'select', value: 'New contract terms', options: ['New contract terms', 'Renewal', 'Amendment / variation', 'Cancellation / termination'], class: 'col-12 col-md-6' },
      { label: 'Condition', type: 'input', placeholder: 'e.g. Above R 500k', class: 'col-12 col-md-6' },
      { label: 'Approver', type: 'input', placeholder: 'e.g. Legal + CFO', class: 'col-12 col-md-6' },
      { label: 'Evidence required', type: 'input', placeholder: 'e.g. Legal review + DoA log', class: 'col-12 col-md-6' }
    ]
  },
  contract_authority_edit: {
    title: 'Edit contract authority',
    subtitle: 'Who approves a contract action and the evidence required.',
    primary_label: 'Save changes',
    secondary_label: 'Delete',
    fields: [
      { label: 'Action', type: 'select', value: 'New contract terms', options: ['New contract terms', 'Renewal', 'Amendment / variation', 'Cancellation / termination'], class: 'col-12 col-md-6' },
      { label: 'Condition', type: 'input', placeholder: 'e.g. Above R 500k', class: 'col-12 col-md-6' },
      { label: 'Approver', type: 'input', placeholder: 'e.g. Legal + CFO', class: 'col-12 col-md-6' },
      { label: 'Evidence required', type: 'input', placeholder: 'e.g. Legal review + DoA log', class: 'col-12 col-md-6' }
    ]
  },
  risk_routing: {
    title: 'New risk-routing rule',
    subtitle: 'When the trigger fires, these approvers are automatically added to the chain.',
    primary_label: 'Create',
    fields: [
      { label: 'Trigger', type: 'input', placeholder: 'e.g. High-risk supplier', class: 'col-12' },
      { label: 'Fires on', type: 'select', value: 'risk', options: ['risk', 'trigger'], class: 'col-12 col-md-6' },
      { label: 'Risk level (for risk-mode)', type: 'select', value: 'Low', options: ['Low', 'Medium', 'High'], class: 'col-12 col-md-6' },
      { label: 'Add approvers (comma-separated)', type: 'input', placeholder: 'Compliance, Legal, Internal Audit', class: 'col-12' },
      { label: 'Rationale', type: 'input', placeholder: 'Why this routing exists', class: 'col-12' },
      { label: 'Active', type: 'select', value: 'Yes', options: ['Yes', 'No'], class: 'col-12 col-md-6' }
    ]
  },
  risk_routing_edit: {
    title: 'Edit risk-routing rule',
    subtitle: 'When the trigger fires, these approvers are automatically added to the chain.',
    primary_label: 'Save changes',
    secondary_label: 'Delete',
    fields: [
      { label: 'Trigger', type: 'input', placeholder: 'e.g. High-risk supplier', class: 'col-12' },
      { label: 'Fires on', type: 'select', value: 'risk', options: ['risk', 'trigger'], class: 'col-12 col-md-6' },
      { label: 'Risk level (for risk-mode)', type: 'select', value: 'Low', options: ['Low', 'Medium', 'High'], class: 'col-12 col-md-6' },
      { label: 'Add approvers (comma-separated)', type: 'input', placeholder: 'Compliance, Legal, Internal Audit', class: 'col-12' },
      { label: 'Rationale', type: 'input', placeholder: 'Why this routing exists', class: 'col-12' },
      { label: 'Active', type: 'select', value: 'Yes', options: ['Yes', 'No'], class: 'col-12 col-md-6' }
    ]
  },
  delegation: {
    title: 'New temporary delegation',
    subtitle: 'Authority handed to a delegate for a fixed period (e.g. while on leave).',
    primary_label: 'Create',
    fields: [
      { label: 'Delegator', type: 'input', placeholder: 'e.g. M. Khan (CFO)', class: 'col-12' },
      { label: 'Authority role delegated', type: 'input', placeholder: 'e.g. Executive (CFO)', class: 'col-12 col-md-6' },
      { label: 'Delegate', type: 'input', placeholder: 'Who receives the authority', class: 'col-12 col-md-6' },
      { label: 'Scope / limit', type: 'input', placeholder: 'e.g. Up to R 1 000 000', class: 'col-12' },
      { label: 'Start date', type: 'input', placeholder: 'e.g. 12 May 2026', class: 'col-12 col-md-6' },
      { label: 'End date', type: 'input', placeholder: 'e.g. 26 May 2026', class: 'col-12 col-md-6' },
      { label: 'Status', type: 'select', value: 'Active', options: ['Active', 'Scheduled', 'Expired'], class: 'col-12 col-md-6' }
    ]
  },
  delegation_edit: {
    title: 'Edit temporary delegation',
    subtitle: 'Authority handed to a delegate for a fixed period (e.g. while on leave).',
    primary_label: 'Save changes',
    secondary_label: 'Delete',
    fields: [
      { label: 'Delegator', type: 'input', placeholder: 'e.g. M. Khan (CFO)', class: 'col-12' },
      { label: 'Authority role delegated', type: 'input', placeholder: 'e.g. Executive (CFO)', class: 'col-12 col-md-6' },
      { label: 'Delegate', type: 'input', placeholder: 'Who receives the authority', class: 'col-12 col-md-6' },
      { label: 'Scope / limit', type: 'input', placeholder: 'e.g. Up to R 1 000 000', class: 'col-12' },
      { label: 'Start date', type: 'input', placeholder: 'e.g. 12 May 2026', class: 'col-12 col-md-6' },
      { label: 'End date', type: 'input', placeholder: 'e.g. 26 May 2026', class: 'col-12 col-md-6' },
      { label: 'Status', type: 'select', value: 'Active', options: ['Active', 'Scheduled', 'Expired'], class: 'col-12 col-md-6' }
    ]
  },
  sod_rule: {
    title: 'New segregation rule',
    subtitle: 'Duties that must be performed by different people.',
    primary_label: 'Create',
    fields: [
      { label: 'Process', type: 'input', placeholder: 'e.g. Procure-to-pay', class: 'col-12' },
      { label: 'Duty 1', type: 'input', placeholder: 'e.g. Request', class: 'col-12 col-md-6' },
      { label: 'Duty 2', type: 'input', placeholder: 'e.g. Approve', class: 'col-12 col-md-6' },
      { label: 'Duty 3', type: 'input', placeholder: 'e.g. Pay', class: 'col-12 col-md-6' },
      { label: 'Rule', type: 'input', placeholder: 'e.g. All three must be different people', class: 'col-12' },
      { label: 'Status', type: 'select', value: 'In force', options: ['In force', 'Review'], class: 'col-12 col-md-6' }
    ]
  },
  sod_rule_edit: {
    title: 'Edit segregation rule',
    subtitle: 'Duties that must be performed by different people.',
    primary_label: 'Save changes',
    secondary_label: 'Delete',
    fields: [
      { label: 'Process', type: 'input', placeholder: 'e.g. Procure-to-pay', class: 'col-12' },
      { label: 'Duty 1', type: 'input', placeholder: 'e.g. Request', class: 'col-12 col-md-6' },
      { label: 'Duty 2', type: 'input', placeholder: 'e.g. Approve', class: 'col-12 col-md-6' },
      { label: 'Duty 3', type: 'input', placeholder: 'e.g. Pay', class: 'col-12 col-md-6' },
      { label: 'Rule', type: 'input', placeholder: 'e.g. All three must be different people', class: 'col-12' },
      { label: 'Status', type: 'select', value: 'In force', options: ['In force', 'Review'], class: 'col-12 col-md-6' }
    ]
  },
  sod_conflict: {
    title: 'New SoD conflict',
    subtitle: 'A detected breach where one person held conflicting duties.',
    primary_label: 'Create',
    fields: [
      { label: 'Person', type: 'input', placeholder: 'e.g. Employee A - Procurement', class: 'col-12' },
      { label: 'Process', type: 'input', placeholder: 'e.g. Procure-to-pay', class: 'col-12 col-md-6' },
      { label: 'Conflict', type: 'input', placeholder: 'What duties overlapped', class: 'col-12' },
      { label: 'Severity', type: 'select', value: 'High', options: ['Low', 'Medium', 'High'], class: 'col-12 col-md-6' },
      { label: 'Status', type: 'select', value: 'Logged', options: ['Logged', 'Escalated', 'Monitoring', 'Resolved'], class: 'col-12 col-md-6' }
    ]
  },
  sod_conflict_edit: {
    title: 'Edit SoD conflict',
    subtitle: 'A detected breach where one person held conflicting duties.',
    primary_label: 'Save changes',
    secondary_label: 'Delete',
    fields: [
      { label: 'Person', type: 'input', placeholder: 'e.g. Employee A - Procurement', class: 'col-12' },
      { label: 'Process', type: 'input', placeholder: 'e.g. Procure-to-pay', class: 'col-12 col-md-6' },
      { label: 'Conflict', type: 'input', placeholder: 'What duties overlapped', class: 'col-12' },
      { label: 'Severity', type: 'select', value: 'High', options: ['Low', 'Medium', 'High'], class: 'col-12 col-md-6' },
      { label: 'Status', type: 'select', value: 'Logged', options: ['Logged', 'Escalated', 'Monitoring', 'Resolved'], class: 'col-12 col-md-6' }
    ]
  },
  authority_exception: {
    title: 'New authority exception',
    subtitle: 'An approval made outside the authority matrix - recorded and escalated.',
    primary_label: 'Create',
    fields: [
      { label: 'Transaction', type: 'input', placeholder: 'What was approved', class: 'col-12' },
      { label: 'Value', type: 'input', placeholder: 'e.g. R 520 000', class: 'col-12 col-md-6' },
      { label: 'What happened', type: 'textarea', placeholder: 'Describe the deviation', class: 'col-12' },
      { label: 'Approved by (actual)', type: 'input', placeholder: 'Who approved it', class: 'col-12 col-md-6' },
      { label: 'Proper authority (required)', type: 'input', placeholder: 'Who should have', class: 'col-12 col-md-6' },
      { label: 'Reason', type: 'input', placeholder: 'Justification given', class: 'col-12' },
      { label: 'Escalated to', type: 'input', placeholder: 'e.g. CEO + Legal', class: 'col-12 col-md-6' },
      { label: 'Status', type: 'select', value: 'Logged', options: ['Logged', 'Escalated', 'Ratified', 'Rejected'], class: 'col-12 col-md-6' }
    ]
  },
  authority_exception_edit: {
    title: 'Edit authority exception',
    subtitle: 'An approval made outside the authority matrix - recorded and escalated.',
    primary_label: 'Save changes',
    secondary_label: 'Delete',
    fields: [
      { label: 'Transaction', type: 'input', placeholder: 'What was approved', class: 'col-12' },
      { label: 'Value', type: 'input', placeholder: 'e.g. R 520 000', class: 'col-12 col-md-6' },
      { label: 'What happened', type: 'textarea', placeholder: 'Describe the deviation', class: 'col-12' },
      { label: 'Approved by (actual)', type: 'input', placeholder: 'Who approved it', class: 'col-12 col-md-6' },
      { label: 'Proper authority (required)', type: 'input', placeholder: 'Who should have', class: 'col-12 col-md-6' },
      { label: 'Reason', type: 'input', placeholder: 'Justification given', class: 'col-12' },
      { label: 'Escalated to', type: 'input', placeholder: 'e.g. CEO + Legal', class: 'col-12 col-md-6' },
      { label: 'Status', type: 'select', value: 'Logged', options: ['Logged', 'Escalated', 'Ratified', 'Rejected'], class: 'col-12 col-md-6' }
    ]
  },
  approval_rule_edit: {
    title: 'Edit matrix rule',
    subtitle: 'Who can approve a transaction, by amount band, department, category and risk.',
    primary_label: 'Save changes',
    secondary_label: 'Delete',
    fields: [
      { label: 'Transaction type', type: 'input', placeholder: 'e.g. Capital expenditure', class: 'col-12' },
      { label: 'Category', type: 'select', value: 'General expenditure', options: ['General expenditure', 'Capital expenditure', 'Procurement / PO', 'Contract value'], class: 'col-12 col-md-6' },
      { label: 'Department', type: 'select', value: 'All', options: ['All', 'Finance', 'Procurement', 'Legal', 'Operations'], class: 'col-12 col-md-6' },
      { label: 'Amount band / condition', type: 'input', placeholder: 'e.g. R 50 000 - R 500 000', class: 'col-12 col-md-6' },
      { label: 'Risk level', type: 'select', value: 'Low', options: ['Low', 'Medium', 'High'], class: 'col-12 col-md-6' },
      { label: 'Required approver', type: 'input', placeholder: 'e.g. Executive (CFO)', class: 'col-12 col-md-6' },
      { label: 'Second approver (if dual)', type: 'input', placeholder: 'Optional', class: 'col-12 col-md-6' },
      { label: 'Note', type: 'input', placeholder: 'Conditions / requirements', class: 'col-12' }
    ]
  }
};


